import {
  OrderItemExportResponseType,
  OrderItemExportRequestType,
} from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useOrderItemExport = <TData = OrderItemExportResponseType,>(
  params: OrderItemExportRequestType,
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  //we are using a query here so the csv gets cached on the client
  return useQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.OrderItemsExport,
      params,
    ],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        responseType: "text",
        path: `order-items/export`,
        params,
      }).then((data) => data.data as TData),
    staleTime: 1000 * 60 * 10,
    ...getDefaultQueryOptionsV2({
      user,
      business: business,
      overrideOptions: options,
    }),
    enabled: false,
  });
};
